import React, { useEffect } from "react";
import { Spin, Typography, Tabs, Col, Row } from "antd";
import {
  usePropertiesState,
  usePropertiesDispatch,
} from "../contexts/properties";
import { actions } from "../contexts/properties/actions";
import { useParams } from "react-router-dom";
import fallback from "../assets/fallback.png";
import OverviewTab from "../components/ListingTabs/OverviewTab";
import FeaturesTab from "../components/ListingTabs/FeaturesTab";
import PriceHistoryTab from "../components/ListingTabs/PriceHistoryTab";
import ListingContactCard from "../components/ListingContactCard";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./listing.css";
import ReviewTab from "../components/ListingTabs/ReviewTab";

function Listing() {
  const { id } = useParams();

  const { property, isPropertyLoading } = usePropertiesState();

  const dispatch = usePropertiesDispatch();

  useEffect(() => {
    actions.getProperty(dispatch, id);
  }, [dispatch, id]);

  const tabs = [
    {
      key: "Overview",
      label: `Overview`,
      children: <OverviewTab property={property.fields} />,
    },
    {
      key: "Features",
      label: `Features`,
      children: <FeaturesTab property={property.fields} />,
    },
    {
      key: "Price",
      label: `Price and Tax History`,
      children: <PriceHistoryTab property={property.fields} />,
    },
    {
      key: "Reviews",
      label: `Reviews`,
      children: <ReviewTab propertyId={property?.fields?.PropertyId} />,
    },
  ];

  return (
    <Spin spinning={isPropertyLoading} delay={500} size="large">
      <Row justify={"center"} style={{ marginTop: 50 }}>
        <Col span={14}>

          <Carousel
            className="carousel-change"
            dynamicHeight={false}
            showArrows={true}
            showStatus={false}
            emulateTouch={true}
          >
            {property?.fields?.Photos ?
              (
                property?.fields?.Photos?.map((images: any, index: any) => {
                  return (
                    <div>
                      <img alt={index} key={index} src={images.url} />
                    </div>
                  );
                })
              ) : (
                <img alt="fallback" src={fallback} />
              )}
          </Carousel>
        </Col>
      </Row>
      <Row justify={"center"} style={{ marginTop: 50 }}>
        <Col
          xs={20} sm={20} md={20} lg={8} xl={8}
        >
          <Row justify={"space-between"}>
            <Typography.Title
              style={{ marginBottom: 0, fontFamily: "Montserrat" }}
              level={3}
            >
              {property?.fields?.StreetNumber} {property?.fields?.Street}
            </Typography.Title>
            <Typography.Title
              style={{ marginBottom: 0, marginRight: 10 }}
              level={4}
            >
              ${property?.fields?.ListingPrice}
            </Typography.Title>
          </Row>

          <Row>
            <Typography.Title style={{ marginTop: 2 }} level={4}>
              {property?.fields?.City}, {property?.fields?.State}{" "}
              {property?.fields?.ZipCode}
            </Typography.Title>
          </Row>
          <Row>
            <Typography.Paragraph>
              <b>
                {property?.fields?.Beds} br | {property?.fields?.Baths} ba |{" "}
                {property?.fields?.SqFt} sqft
              </b>
            </Typography.Paragraph>
          </Row>

          <Row>
            <Col>
              <Typography.Paragraph>
                Est. Fully Occupied Rent:{" "}
              </Typography.Paragraph>
              <Typography.Paragraph>
                Est. Capitalization Rate:{" "}
              </Typography.Paragraph>
              <Typography.Paragraph>
                Est. Property Insurance:{" "}
              </Typography.Paragraph>
            </Col>
            <Col offset={1}>
              <Typography.Paragraph>
                <b>
                  {property?.fields?.EstFullyOccupiedRent
                    ? `$${property?.fields?.EstFullyOccupiedRent?.toLocaleString()}/month`
                    : "N/A"}
                </b>
              </Typography.Paragraph>
              <Typography.Paragraph>
                <b>
                  {property?.fields?.EstCapitalizationRate
                    ? `${property?.fields?.EstCapitalizationRate}%`
                    : "N/A"}
                </b>
              </Typography.Paragraph>
              <Typography.Paragraph>
                <b>
                  {property?.fields?.EstPropertyInsurance
                    ? `$${property?.fields?.EstPropertyInsurance?.toLocaleString()}/month`
                    : "N/A"}
                </b>
              </Typography.Paragraph>
            </Col>
          </Row>

          <Row gutter={{ xs: 20, sm: 20, md: 20, lg: 24, xl: 24 }}>
            <Tabs defaultActiveKey="Overview" items={tabs} />
          </Row>
        </Col>

        <Col>
          <ListingContactCard />
        </Col>
      </Row>
    </Spin>
  );
}

export default Listing;
